<template>
  <div>
    <van-sticky>
      <nav-bar class="home-nav">
        <div slot="left" @click="onClickLeft">返回</div>
        <div slot="center">场馆列表</div>
      </nav-bar>

      <van-cell title="选择日期" size="large" :value="calendarDate" @click="calendarShow = true"/>
      <van-calendar :min-date="minDate" :max-date="maxDate" v-model="calendarShow"
                    @confirm="onCalendarConfirm"/>
    </van-sticky>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        loading-text="努力加载中"
      >
        <van-swipe-cell v-for="item in VenueList" :key="item.id">

          <van-cell :border="false" :label="'最大人数:'+item.maxp"
                    :title="item.vname+item.time" value="<<滑动<<"/>
          <template slot="right">
            <van-button square type="info" @click="SelectVenue(item)" text="预约"/>
            <van-button square type="primary" @click="lookVenue(item.id)" text="详情"/>
          </template>
        </van-swipe-cell>

      </van-list>
    </van-pull-refresh>

    <van-action-sheet v-model="descriptionShow" :title="this.title+' 场馆介绍'+' 当前人数:'+this.countp">
      <van-notice-bar wrapable left-icon="volume-o">
        <p>预约开始时间 {{ new Date(parseInt(this.startTime)).toLocaleString() }}</p>
        <p>场馆开放时间 {{ new Date(parseInt(this.openTime)).toLocaleString() }}</p>
        <p>场馆关闭时间'{{ new Date(parseInt(this.closeTime)).toLocaleString() }}</p>
      </van-notice-bar>
      <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
        '场馆位置' {{ this.location }}
      </van-notice-bar>

      <div style="  padding: 16px 16px 70px;font-size: 18px;font-family: 楷体;">{{ this.description }}</div>

      <div style="padding-top: 50px"></div>
    </van-action-sheet>

  </div>
</template>

<script>
import Vue from 'vue';
import {
  Tab,
  Tabs,
  Field,
  Popup,
  Cell,
  Button,
  PullRefresh,
  List,
  SwipeCell,
  Toast, Dialog,
  Sticky,
  ActionSheet,
  NoticeBar,
  Row,
  Col, Calendar
} from 'vant';

Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(Button);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(SwipeCell);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Sticky);
Vue.use(ActionSheet);
Vue.use(NoticeBar);
Vue.use(Row);
Vue.use(Col);
Vue.use(Calendar);
import NavBar from "components/common/navbar/NavBar";
import {getVenueList, SelectVenue, GetVenueCountById} from "@/network/venue";

export default {
  name: "VenueSList",
  components: {NavBar},
  data() {
    return {
      //Calendar 日历
      calendarShow: false,
      calendarDate: '',
      minDate: this.GLOBAL.start_select_time,
      maxDate: this.GLOBAL.end_select_time,
      years: 2020,
      months: 9,
      days: 1,

      //venue list
      VenueList: [],

      //refresh
      refreshing: false,
      loading: false,
      finished: true,

      //ActionSheet
      descriptionShow: false,
      title: "",
      location: "",
      startTime: "",
      openTime: "",
      closeTime: "",
      description: "",
      countp: 0,
    }
  },
  activated() {
    let now = new Date();
    this.years = now.getFullYear();
    this.months = now.getMonth() + 1;
    this.days = now.getDate();
    this.calendarDate = `${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}`;

    this.getVenueLists();


  },
  methods: {
    onClickLeft() {
      this.$router.replace("/home");
    },
    //refresh
    onLoad() {
      setTimeout(() => {
        this.refreshing = false;
        Toast('刷新成功');
      }, 1500);
    },
    onRefresh() {
      // 清空列表数据;
      this.VenueList = [];
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
      setTimeout(() => {
        // 重新加载数据
        this.getVenueLists();
        this.isLoading = false;
      }, 1000);
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onCalendarConfirm(date) {
      this.years = date.getFullYear();
      this.months = date.getMonth() + 1;
      this.days = date.getDate();
      this.getVenueLists();
      this.calendarDate = this.formatDate(date);
      this.calendarShow = false;
    },
    parseDate(date) {
      if (date >= 10)
        return date;
      return '0' + date;
    },
    getVenueLists() {
      getVenueList(this.years, this.months, this.days).then(res => {
        this.VenueList = res;
        for (let i = 0; i < this.VenueList.length; i++) {
          let d1 = new Date(parseInt(this.VenueList[i].opHours));
          let d2 = new Date(parseInt(this.VenueList[i].clHours));
          let time = ' ' + this.parseDate(d1.getHours()) + ':' + this.parseDate(d1.getMinutes()) + '-' + this.parseDate(d2.getHours()) + ':' + this.parseDate(d2.getMinutes());
          this.VenueList[i]['time'] = time;
        }
      })
    },
    SelectVenue(item) {
      let times = new Date();
      if (parseInt(item.bkTime) > times.getTime()) {
        Toast.fail('未到预约时间');
        return;
      }
      // if (parseInt(item.opHours) < times.getTime()) {
      //   Toast.fail('俱乐部活动开始后不能预约哦');
      //   return;
      // }
      Dialog.confirm({
        title: '提示',
        message: item.vname + ' 确定要选择吗'
      }).then(() => {
        SelectVenue(item.id).then(res => {
            if (res.selected) {
              // Dialog({message: '预约成功，预约记录点击 “我的->当前俱乐部->预约详情”即可查看'});
              this.$router.push({path: 'VSuccess', query: {title: item.vname}})
            } else {
              Toast.fail(res.msg);
            }
          }
        ).catch(res => {
          Toast.fail("预约失败");
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    lookVenue(id) {
      let venue = this.VenueList.filter(item => item.id === id)[0];
      this.title = venue.title;
      this.location = venue.location;
      this.startTime = venue.bkTime;
      this.openTime = venue.opHours;
      this.closeTime = venue.clHours;
      this.description = venue.notice;
      GetVenueCountById(venue.id).then(res => {
        this.countp = res;
      })
      this.descriptionShow = true;
    },
  }

}
</script>

<style scoped>

</style>
